import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';
import { fetchHierarchickyCiselnikTree } from '../../../client/external/ciselniky/hierarchickyCiselnikTree';
import CiselnikPolozkaNode from '../../../model/ciselniky/CiselnikPolozkaNode';

interface ReturnType {
  hierarchickyCiselnikTreeList: CiselnikPolozkaNode[];
  hierarchickyCiselnikTreeStatus: ClientStatus;
}

export default (typ: TypCiselnikaEnum, execute = true): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(fetchHierarchickyCiselnikTree, [typ, execute], [execute]);
  return {
    hierarchickyCiselnikTreeList: data,
    hierarchickyCiselnikTreeStatus: status,
  };
};
